// @core/api/endpoints/notifications/get_contact.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ContactResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Get contact by ID
 * Retrieves a specific contact by its unique identifier. Returns the contact details including verification status and preferences.
 */
export async function GetContact(
  contact_id: string,
  options?: RequestOptions
): Promise<ContactResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/contacts/:contact_id`;
  requestPath = requestPath.replace(':contact_id', encodeURIComponent(contact_id));
  const requestOptions = options;
  return client.get<ContactResponse>(requestPath, { ...requestOptions });
}
